<template>
  <div class="box">
    <h2 class="proTitleStyle">担保金缴存说明</h2>
    <div>
      <div class="titleStyle">1、还款账户为浦发一类户如何缴存</div>
      <p class="textStyle">
        需要保证该还款账户上余额大于需缴存的担保金金额。如不足，请先通过手机银行转账至该账户。
      </p>
      <div class="titleStyle">2、还款账户为浦发二类户如何缴存？</div>
      <p class="textStyle">
        可点击充值按钮，将绑定的一类户资金转入该二类户。
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InstructionsInfo',
  data() {
    return {};
  },
};
</script>
<style scoped>
.proTitleStyle {
  margin: 0;
  padding: 14px;
  font-size: 16px;
  text-align: left;
  color: #1c2438;
  border-bottom: 1px solid #e9f0f5;
  margin-bottom: 12px;
}
.titleStyle {
  margin: 0;
  padding-left: 14px;
  font-size: 14px;
  color: #1c2438;
  text-align: left;
}
.textStyle {
  margin: 0;
  padding: 8px 16px 16px 30px;
  font-size: 14px;
  color: #9ea7b4;
  text-align: left;
}
.box {
  margin-bottom: 42px;
}
</style>
